import { useCallback } from "react";
import { VideoSource } from "../../Enums/enums";

/**
 * "Duplicate all": the other platforms of the open tab's WGID become Step 3's
 * Duplicate of this platform (user request 2026-10-06) — the same
 * `{ source: DUPLICATE, duplicateOf }` a card's own Duplicate choice writes,
 * so Step 3 shows it and publishing reuses this platform's one render.
 *
 * Platforms are picked one by one (user request 2026-10-07): `plan(source,
 * picked)` lists the candidates and which of them `picked` (a Set of platform
 * names) would change; without `picked` it is the default pick — every
 * platform that has no saved edit of its own. `run` writes the targets.
 */
export default function useApplyToAll({ items, onConfigChange }) {
  const plan = useCallback(
    (sourceItem, picked) => {
      const inScope = items.filter((i) => i.key !== sourceItem.key && i.videoKey === sourceItem.videoKey);
      const already = inScope.filter((i) => i.config?.source === VideoSource.DUPLICATE && i.config?.duplicateOf === sourceItem.platform);
      const candidates = inScope.filter((i) => !already.includes(i));
      // A platform with its own saved edit is only replaced when ticked.
      const edited = candidates.filter((i) => i.config?.source === VideoSource.EDITED && i.config?.renderPayload);
      const defaults = candidates.filter((i) => !edited.includes(i));
      const targets = picked ? candidates.filter((i) => picked.has(i.platform)) : defaults;
      return { inScope, already, candidates, edited, defaults, targets };
    },
    [items],
  );

  const run = useCallback(
    (sourceItem, picked) => {
      const { targets } = plan(sourceItem, picked);
      targets.forEach((i) =>
        onConfigChange(i.brandName, i.wgid, i.platform, {
          source: VideoSource.DUPLICATE,
          duplicateOf: sourceItem.platform,
          renderPayload: null,
          batchApplied: null,
        }),
      );
      return targets;
    },
    [plan, onConfigChange],
  );

  return { plan, run };
}
